module.exports = __webpack_public_path__ + "media/images/logos/sus-schaag-4f79d2748b30a96e14e2902b48857f36.png";